import { Textual }	from "@v3/data/textual";

// ATTENTION is not disjunct from Fqdn!
export type IpV4	= Textual.Value<typeof IpV4>;

/*
0				0
[1-9]			1-9
[1-9][0-9]		10-99
1[0-9][0-9]		100-199
2[0-4][0-9]		200-249
25[0-5]			250-255
*/
export const IpV4	=
	Textual.regex(
		"IpV4",
		/^(0|[1-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(\.(0|[1-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3}$/,
		"must be an ip address version 4"
	);
